import { render, staticRenderFns } from "./FinanceTable.vue?vue&type=template&id=3daf93a4&"
import script from "./FinanceTable.vue?vue&type=script&lang=ts&"
export * from "./FinanceTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports